"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MMS = void 0;
var types_1 = require("./types");
var version_json_1 = require("../version.json");
var WCS_1 = require("./WCS");
var axios_1 = require("axios");
var MMS = /** @class */ (function () {
    function MMS(serviceList) {
        this.serviceList = serviceList;
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.eventMap = new Map();
        this.curServiceIdx = 0;
        if (!serviceList.length)
            throw new Error('one service at least');
        this.createService(this.serviceList[this.curServiceIdx]);
    }
    MMS.prototype.createService = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var commonOption;
            return __generator(this, function (_a) {
                commonOption = {
                    country: options.country,
                    env: options.env,
                    biz: options.biz,
                    vid: options.vid,
                    sdkVersion: 'mms-' + version_json_1.version,
                    serviceId: options.serviceID,
                    serviceIndex: options.serviceIndex
                };
                switch (options.serviceID) {
                    case types_1.ServiceID.shopeeuss:
                        this.service = Promise.resolve().then(function () { return require('uss-vod-js-sdk'); }).then(function (_a) {
                            var USSVod = _a.default;
                            return new USSVod(options);
                        });
                        break;
                    // case ServiceID.txcloud:
                    //   this.service = import('./TcVod').then(
                    //     ({ TcVod }) =>
                    //       new TcVod({
                    //         getSignature: () => Promise.resolve(options.authorization),
                    //         ...commonOption
                    //       })
                    //   )
                    //   break
                    case types_1.ServiceID.wscloud:
                        this.service = Promise.resolve().then(function () { return require('./WCS'); }).then(function (_a) {
                            var WCS = _a.WCS;
                            return new WCS(__assign({ authorization: options.authorization, uploadDomain: options.uploadDomain, domain: options.domain }, commonOption));
                        });
                        break;
                    case types_1.ServiceID.awscloud:
                        this.service = Promise.resolve().then(function () { return require('./AWS'); }).then(function (_a) {
                            var AWS = _a.AWS;
                            return new AWS(__assign({ authorization: options.authorization, coverToken: options.coverToken, domain: options.domain }, commonOption));
                        });
                        break;
                    default:
                        this.curServiceIdx++;
                        if (this.curServiceIdx >= this.serviceList.length) {
                            throw new Error("Unrecognized serviceID, serviceID must be one of ".concat(Object.values(types_1.ServiceID)
                                .map(function (s) { return "'".concat(s, "'"); })
                                .join(' | ')));
                        }
                        else {
                            this.createService(this.serviceList[this.curServiceIdx]);
                        }
                }
                return [2 /*return*/];
            });
        });
    };
    MMS.prototype.subscribe = function () {
        var _this = this;
        this.uploader.on(types_1.UploaderEvents.mediaUpload, function (data) {
            return _this.emit(types_1.UploaderEvents.mediaUpload, data);
        });
        this.uploader.on(types_1.UploaderEvents.coverUpload, function (data) {
            return _this.emit(types_1.UploaderEvents.coverUpload, data);
        });
        this.uploader.on(types_1.UploaderEvents.mediaProgress, function (data) {
            return _this.emit(types_1.UploaderEvents.mediaProgress, __assign(__assign({}, data), { curService: _this.serviceList[_this.curServiceIdx].serviceID }));
        });
        this.uploader.on(types_1.UploaderEvents.coverProgress, function (data) {
            return _this.emit(types_1.UploaderEvents.coverProgress, __assign(__assign({}, data), { curService: _this.serviceList[_this.curServiceIdx].serviceID }));
        });
    };
    MMS.prototype.upload = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.uploadParams = __assign({}, params);
                        _a = this;
                        return [4 /*yield*/, this.service];
                    case 1:
                        _a.uploader = (_b.sent()).upload(params);
                        this.subscribe();
                        return [2 /*return*/, this.uploader];
                }
            });
        });
    };
    MMS.prototype.done = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 7]);
                        _a = [{}];
                        return [4 /*yield*/, this.uploader.done()];
                    case 1: return [2 /*return*/, __assign.apply(void 0, [__assign.apply(void 0, _a.concat([(_c.sent())])), { finalService: this.serviceList[this.curServiceIdx]
                                    .serviceID }])];
                    case 2:
                        error_1 = _c.sent();
                        if (!(axios_1.default.isCancel(error_1 === null || error_1 === void 0 ? void 0 : error_1.error) ||
                            (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) === WCS_1.abortErrorMessage ||
                            this.curServiceIdx + 1 >= this.serviceList.length)) return [3 /*break*/, 3];
                        throw error_1;
                    case 3:
                        this.curServiceIdx++;
                        this.createService(this.serviceList[this.curServiceIdx]);
                        //@ts-ignore
                        _b = this;
                        return [4 /*yield*/, this.service];
                    case 4:
                        //@ts-ignore
                        _b.uploader = (_c.sent()).upload(this.uploadParams);
                        this.subscribe();
                        return [4 /*yield*/, this.done()];
                    case 5: return [2 /*return*/, _c.sent()];
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MMS.prototype.cancel = function () {
        this.uploader.cancel();
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    MMS.prototype.on = function (eventName, callback) {
        var callbacks = this.eventMap.get(eventName) || new Set();
        callbacks.add(callback);
        this.eventMap.set(eventName, callbacks);
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    MMS.prototype.off = function (eventName, callback) {
        var callbacks = this.eventMap.get(eventName);
        if (callbacks) {
            callbacks.delete(callback);
            if (callbacks.size === 0) {
                this.eventMap.delete(eventName);
            }
        }
    };
    MMS.prototype.emit = function (eventName, params) {
        var callbacks = this.eventMap.get(eventName);
        if (callbacks) {
            callbacks.forEach(function (callback) {
                callback(params);
            });
        }
    };
    MMS.version = version_json_1.version;
    return MMS;
}());
exports.MMS = MMS;
